import React from "react";

const SearchButton = () => {
  return (
    <div className="Search">
      <button className="btn btn-primary">Search</button>
    </div>
  );
};

export default SearchButton;
